import React from 'react';
import { TabbedForm as RATabbedForm } from 'react-admin';

const TabbedForm = ({ variant = 'outlined', ...props }) => (
	<RATabbedForm variant={variant} {...props} />
);

export default TabbedForm;